import {SxProps, Typography} from '@mui/material';
import { Box } from '@mui/material';
import * as Preact from 'preact';
import * as Close from './M_BarsClose';
import {useTheme} from '@mui/material/styles';
import {isSmallScreen} from './domain/theme/breakpoints';

export interface Props {
    onCloseClick: () => void;
    title?: string;
    sx?: SxProps;
}

export const Component = (p: Props) => {

    const theme = useTheme();
    const isSmall = isSmallScreen(theme);

    return (
        <Box sx={{
            height: isSmall ? '61px' : '44px',
            display: 'flex',
            width: '100%',
            maxWidth: isSmall ? 'inherit' : '398px',
            boxSizing: isSmall ? 'border-box' : 'content-box',
            padding: isSmall ? '16px' : '8px 24px 10px 24px',
            alignItems: 'center',
            ...p.sx
        }}>
            {isSmall && (
                <Typography variant="h6" sx={{ width: '100%' }}>
                    {p.title}
                </Typography>
            )}
            <Close.Component onCloseClick={p.onCloseClick} sx={{ padding: '0px', width: isSmall ? 'auto' : '100%'}}/>
        </Box>
    );
};

Component.displayName = 'BasketNavigation';
